/*
 * Matching-shorts add-on (snippets/hoopers-shorts-addon).
 *
 * The shorts are a second cart line, never a property of the shirt. When the
 * box is ticked and the shopper is buying the shirt on its own, this file
 * sends shirt + shorts in one request. When the set widget is in set mode it
 * owns the submit, and asks window.hsaExtra for the shorts line instead.
 */
(function () {
  if (window.__hsa) return;
  window.__hsa = 1;

  function init(el) {
    if (el.dataset.hsaBound) return;
    el.dataset.hsaBound = '1';
    var form = el.closest('form');
    if (!form) return;
    var check = el.querySelector('[data-hsa-check]');
    var sel = el.querySelector('[data-hsa-size]');
    var err = el.querySelector('.hsa-error');
    var idSel = form.querySelector('select[name="id"], input[name="id"]');
    var btn = form.querySelector('[data-add-to-cart]');
    var touched = false;

    function isOn() { return !!(check && check.checked); }

    var nowEl = el.querySelector('.hsa-now');
    var wasEl = el.querySelector('.hsa-was');
    var addText = nowEl ? nowEl.textContent : '';
    var fullText = wasEl ? '+' + (wasEl.textContent || '').trim() : addText;

    function setMode() {
      var r = form.querySelector('input.hb-radio:checked');
      return !!r && r.value === 'bundle';
    }

    /* A shirt gets one set price in checkout. When the shopper takes the pair
       of shirts, the shorts are charged in full, so the box says the full
       price instead of the add-on price. The buy drawer sums every checked
       `.hup input[data-hup-price]` for its button, so the same number goes
       there and the button and the cart always agree. */
    function syncPrice() {
      if (!nowEl) return;
      var full = setMode() && !!wasEl;
      nowEl.textContent = full ? fullText : addText;
      if (wasEl) wasEl.hidden = full;
      var n = (nowEl.textContent || '').replace(/[^\d.]/g, '');
      if (check && n) check.setAttribute('data-hup-price', n);
    }

    /* The buy drawer moves the size picker and the extras into its sheet.
       Sitting inside .hup puts the shorts next to the patch and the player
       version. The upsell script only reads .hup__in inputs, so nothing here
       becomes a property of the shirt. */
    function dock() {
      var slot = form.querySelector('[data-hbd-slot]');
      var hup = slot && slot.querySelector('.hup');
      if (!hup) return false;
      if (el.parentNode !== hup) hup.appendChild(el);
      syncPrice();
      return true;
    }
    if (!dock()) {
      var tries = 0;
      var timer = window.setInterval(function () {
        if (dock() || ++tries > 50) window.clearInterval(timer);
      }, 200);
    }
    // Capture phase, so the price is settled before the drawer re-totals.
    form.addEventListener('change', syncPrice, true);

    // The thumbnail sits inside the label; opening the gallery must not tick the box.
    var zoom = el.querySelector('[data-hsa-zoom]');
    function openGallery(e) {
      e.preventDefault();
      e.stopPropagation();
      var list = (zoom.getAttribute('data-hsa-imgs') || '').split('|').filter(Boolean);
      if (!list.length || !window.hbLightbox) return;
      window.hbLightbox().open(list, zoom.getAttribute('data-hsa-ttl') || '', '');
    }
    if (zoom) {
      zoom.addEventListener('click', openGallery);
      zoom.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') openGallery(e);
      });
    }

    // The shirt's selected size, read from the form's own variant select.
    function shirtSize() {
      if (!idSel || !idSel.options) return '';
      var o = idSel.options[idSel.selectedIndex];
      return o ? (o.textContent || '').split(' - ')[0].trim() : '';
    }

    // Until the shopper picks a shorts size, follow the shirt's size.
    function followShirt() {
      if (touched || !sel) return;
      var t = shirtSize();
      if (!t) return;
      for (var i = 0; i < sel.options.length; i++) {
        var o = sel.options[i];
        if (o.getAttribute('data-title') === t && !o.disabled) { sel.value = o.value; return; }
      }
    }

    function showError(on) { if (err) err.hidden = !on; }

    // null = not wanted, false = wanted but no size chosen, object = the line.
    el.hsaItem = function () {
      if (!isOn()) return null;
      if (!sel || !sel.value) { showError(true); return false; }
      return { id: Number(sel.value), quantity: 1 };
    };

    if (check) {
      check.addEventListener('change', function () {
        el.classList.toggle('is-on', isOn());
        showError(false);
        followShirt();
      });
    }
    if (sel) {
      sel.addEventListener('change', function () { touched = true; showError(false); });
    }
    form.addEventListener('change', function (e) {
      if (e.target === sel || e.target === check) return;
      window.setTimeout(followShirt, 60);
    });

    document.addEventListener('submit', function (e) {
      if (e.target !== form) return;
      if (!isOn()) return;
      var mode = form.querySelector('input.hb-radio:checked');
      if (mode && mode.value === 'bundle') return; // the set widget sends the request

      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      if (el.dataset.hsaBusy === '1') return;

      var shorts = el.hsaItem();
      if (shorts === false) return;

      var props = {};
      var qty = 1;
      try {
        var fd = new FormData(form);
        fd.forEach(function (v, k) {
          var m = k.match(/^properties\[(.+)\]$/);
          if (m && v) props[m[1]] = v;
          if (k === 'quantity' && Number(v) > 0) qty = Number(v);
        });
      } catch (ignore) {}
      if (!idSel || !idSel.value) return;
      var items = [{ id: Number(idSel.value), quantity: qty, properties: props }, shorts];

      el.dataset.hsaBusy = '1';
      if (btn) btn.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) {
          if (!r.ok) throw new Error('add failed');
          return r.json();
        })
        .then(function () {
          el.dataset.hsaBusy = '';
          if (btn) btn.disabled = false;
          document.dispatchEvent(new CustomEvent('cart:build'));
          var t = document.querySelector('.js-drawer-open-cart');
          if (t) { t.click(); } else { window.location.href = '/cart'; }
        })
        .catch(function () {
          el.dataset.hsaBusy = '';
          if (btn) btn.disabled = false;
          if (err) {
            err.textContent = 'לא הצלחנו להוסיף לעגלה. נסו שוב.';
            err.hidden = false;
          }
        });
    }, true);
  }

  // Used by assets/hoopers-bundle-cart.js when the set widget owns the submit.
  window.hsaExtra = function (form) {
    var el = form && form.querySelector('[data-hsa]');
    if (!el || !el.hsaItem) return { ok: true, items: [] };
    var it = el.hsaItem();
    if (it === null) return { ok: true, items: [] };
    if (it === false) return { ok: false, items: [] };
    return { ok: true, items: [it] };
  };

  function boot() {
    var l = document.querySelectorAll('[data-hsa]');
    for (var i = 0; i < l.length; i++) init(l[i]);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
